<template>
  <div class="landing-info">
    <div v-for="(item,index) in items" :key="index" class="landing-info__item"
         :class="[
           {'landing-info__item_odd': !isOdd(index)},
           item.class ? `item-${item.class}` : '']"
    >
      <VContainer>
        <VRow :class="{'flex-row-reverse': !isOdd(index)}" no-gutters>
          <VCol :class="{'justify-center': !isOdd(index)}"
                class="d-sm-flex col-12 justify-center" md="6"
          >
            <div class="landing-info__image-wrap">
              <img
                :src="require(`../../assets/img/landing/info/${item.image}`)"
                :srcset="item.image2 ?
                  require(`../../assets/img/landing/info/${item.image2}`) + ' 2x': undefined"
                alt=""
                class="landing-info__image"
              >
              <div v-if="index === '1'" class="interviewers-name">
                <div class="interviewers-name__item">
                  {{ $t('interviewersName1') }}
                </div>
                <div class="interviewers-name__item">
                  {{ $t('interviewersName2') }}
                </div>
                <div class="interviewers-name__item">
                  {{ $t('interviewersName3') }}
                </div>
              </div>
            </div>
          </VCol>
          <VCol :offset-lg="isOdd(index) ? undefined : 1"
                class="d-flex justify-center"
          >
            <div class="landing-info__text-wrap">
              <div class="landing-info__name text-center text-md-left" v-html="item.title" />
              <div class="landing-info__text text-left" v-html="item.text" />
            </div>
          </VCol>
        </VRow>
      </VContainer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingQrInfo',
  data() {
    return {
      items: this.$t('items'),
    };
  },
  methods: {
    isOdd(index) {
      return index % 2 === 0;
    },
  },
};
</script>

<style scoped lang="scss">
  .landing-info {
    padding-top: 2.125rem;
    overflow: hidden;
    &__item {
      position: relative;
      background-color: #FFFFFF;
      &_odd {
        background-color: #E9F3FE;
      }
      &.item-intro {
        padding-bottom: 4rem;
        &:after {
          content: url("../../assets/img/landing/info/info1-bg.svg");
          position: absolute;
          top: 11.5625rem;
          right: 0;
        }
        .landing-info__text-wrap {
          padding-top: 2.125rem;
        }
      }
      &.item-create {
        .landing-info__text-wrap {
          padding-top: 8.5rem;
        }
        .interviewers-name {
          display: block;
        }
      }
      &.item-test {
        padding-top: 0.75rem;
        &:after {
          width: 8.75rem;
          height: 4.1875rem;
          content: '';
          background: url("../../assets/img/landing/info/info3-bg.svg") no-repeat center;
          background-size: contain;
          position: absolute;
          top: 8.25rem;
          right: 3%;
        }
        .landing-info__text-wrap {
          padding-top: 7.125rem;
        }
      }
      &.item-conveniently {
        &:after {
          content: '';
          position: absolute;
          left: 1.25rem;
          bottom: 1.25rem;
          background: url("../../assets/img/landing/info/info4-bg.svg") no-repeat center;
          background-size: contain;
        }
        .landing-info__image-wrap {
          padding-top: 2.75rem;
          &:after {
            width: 17.25rem;
            height: 14rem;
            content: '';
            background: url("../../assets/img/landing/info/info4-lens.svg") no-repeat center;
            background-size: contain;
            position: absolute;
            right: -8.125rem;
            bottom: 3.875rem;
            z-index: 3;
          }
        }
        .landing-info__text-wrap {
          padding-top: 12.5rem;
        }
      }
      &.item-aggregators {
        .landing-info__image-wrap {
          padding-top: 8.5rem;
          &:before {
            width: 14.5rem;
            height: 13rem;
            content: '';
            background: url("../../assets/img/landing/info/info5-bg.svg") no-repeat center top;
            background-size: contain;
            position: absolute;
            top: 4.75rem;
            right: -5rem;
            z-index: 1;
          }
        }
        .landing-info__image {
          position: relative;
          z-index: 2;
        }
        .landing-info__text-wrap {
          padding-top: 10rem;
        }
      }
      &.item-office {
        padding: 5rem 0 3.5rem;
        .landing-info__image-wrap {
          padding-top: 1.75rem;
        }
      }
      &.item-integrate {
        .landing-info__image-wrap {
          padding-top: 4.25rem;
          &:after {
            width: 12rem;
            height: 8.125rem;
            content: '';
            background: url("../../assets/img/landing/info/info7-img.svg") no-repeat center top;
            background-size: 100%;
            position: absolute;
            left: -7.75rem;
            bottom: 6rem;
            z-index: 3;
          }
        }
        .landing-info__text-wrap {
          padding-top: 12.125rem;
        }
      }
      &.item-qr {
        .landing-info__image-wrap {
          bottom: -1.25rem;
          &:after {
            width: 14.5rem;
            height: 12.5rem;
            content: '';
            background: url("../../assets/img/landing/info/info8-bg.svg") no-repeat center top;
            background-size: contain;
            position: absolute;
            bottom: -6rem;
            right: -30%;
            z-index: 1;
          }
        }
        .landing-info__text-wrap {
          padding-top: 4.5rem;
          padding-bottom: 2.5rem;
          &:before {
            width: 14.5rem;
            height: 12.5rem;
            content: '';
            background: url("../../assets/img/landing/info/info8-bg.svg") no-repeat center top;
            background-size: contain;
            position: absolute;
            top: 3.25rem;
            left: -70%;
            z-index: 1;
          }
        }
        .landing-info__name {
          max-width: 22rem;
        }
      }
    }
    &__image-wrap {
      display: inline-block;
      position: relative;
    }
    &__image {
      max-width: 100%;
      height: auto;
      position: relative;
      z-index: 2;
    }
    &__text-wrap {
      padding-top: 2.125rem;
      max-width: 428px;
      color: #666666;
      font-size: 1.125rem;
      line-height: 1.55;
      position: relative;
      z-index: 2;
    }
    &__name {
      color: #000;
      font-size: 2rem;
      font-weight: 500;
      line-height: 1.19;
      margin-bottom: 1.25rem;
    }
  }
  .interviewers-name {
    display: none;
    &__item {
      display: flex;
      align-items: center;
      width: 9.0625rem;
      height: 3rem;
      border-radius: 1.5rem 1.5rem 0 1.5rem;
      color: #fff;
      font-size: 1.125rem;
      padding: 0.71875rem 1.625rem;
      box-shadow: 0px 14px 32px rgba(0, 0, 0, 0.08);
      position: absolute;
      z-index: 3;
      &:nth-child(1) {
        background-color: #026DAC;
        left: -3.25rem;
        top: 11.75rem;
      }
      &:nth-child(2) {
        border-radius: 1.5rem 1.5rem 1.5rem 0;
        background-color: #1FC57F;
        right: -5.5rem;
        top: 12rem;
      }
      &:nth-child(3) {
        background-color: #02A2AC;
        left: 3.25rem;
        bottom: 6rem;
      }
    }
  }

  @media only screen and (max-width: 1500px) {
    .landing-info {
      &__item {
        &.item-create {
          .landing-info__text-wrap {
            padding-top: 4rem;
          }
          .landing-info__image-wrap {
            padding: 0 5rem;
          }
        }
        &.item-test {
          &:after {
            width: 8rem;
            right: 1%;
          }
        }
        &.item-conveniently {
          .landing-info__text-wrap {
            padding-top: 9.25rem;
          }
          .landing-info__image-wrap {
            padding: 2.5rem 6rem 0 0;
            &:after {
              width: 15rem;
              right: 0;
              bottom: 2rem;
            }
          }
        }
        &.item-integrate {
          .landing-info__image-wrap {
            padding-left: 6.5rem;
            &:after {
              width: 10rem;
              left: 0;
              bottom: 3.5rem;
            }
          }
          .landing-info__text-wrap {
            padding-top: 10rem;
          }
        }
      }
    }
    .interviewers-name {
      &__item {
        width: 8rem;
        height: 2.625rem;
        border-radius: 1.3125rem 1.3125rem 0 1.3125rem;
        font-size: 1rem;
        padding: 0.71875rem 1.625rem;
        &:nth-child(1) {
          left: 1rem;
          top: 7.75rem;
        }
        &:nth-child(2) {
          border-radius: 1.3125rem 1.3125rem 1.3125rem 0;
          right: 0;
          top: 8rem;
        }
        &:nth-child(3) {
          left: 5.5rem;
          bottom: 4.5rem;
        }
      }
    }
  }

  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .landing-info {
      &__item {
        &.item-intro {
          padding-bottom: 3rem;
          &:after {
            top: 5rem;
            right: -4rem;
          }
          .landing-info__text-wrap {
            padding-top: 1.125rem;
          }
        }
        &.item-create {
          padding: 2rem 0 1rem;
          .landing-info__text-wrap {
            padding: 2rem 3.5rem 0 0;
          }
          .landing-info__image-wrap {
            padding: 0 3rem 0 0;
          }
        }
        &.item-test {
          &:after {
            top: 4rem;
            right: 2.5rem;
            width: 7rem;
          }
          .landing-info__text-wrap {
            padding-top: 4rem;
          }
        }
        &.item-conveniently {
          .landing-info__text-wrap {
            padding-top: 6rem;
          }
          .landing-info__image-wrap {
            padding: 2rem 3rem 0 0;
            &:after {
              width: 10rem;
              right: -1rem;
              bottom: -0.5rem;
            }
          }
        }
        &.item-aggregators  {
          .landing-info__image-wrap {
            padding-top: 4.5rem;
            &:before {
              width: 10rem;
              top: 1.875rem;
              right: -1rem;
            }
          }
          .landing-info__text-wrap {
            padding-top: 6rem;
          }
        }
        &.item-office {
          padding: 3rem 0 3rem;
          .landing-info__image-wrap {
            padding-top: 2rem;
            padding-left: 2rem;
          }
        }
        &.item-integrate {
          .landing-info__image-wrap {
            padding-top: 2rem;
            padding-left: 5.5rem;
            &:after {
              width: 8rem;
              height: 6rem;
              left: 0;
              bottom: 4.5rem;
            }
          }
          .landing-info__text-wrap {
            padding-top: 4.5rem;
          }
        }
        &.item-qr {
          .landing-info__image-wrap {
            bottom: 0;
            &:after {
              width: 11.6rem;
              height: 10rem;
              bottom: -6rem;
              right: -40%;
            }
          }
          .landing-info__text-wrap {
            padding-top: 2rem;
            &:before {
              width: 11.6rem;
              height: 10rem;
              top: 2.25rem;
              left: -50%;
            }
          }
          .landing-info__name {
            max-width: 23rem;
          }
        }
      }
      &__image-wrap {
        text-align: center;
        max-width: 38rem;
      }
      &__image {
        display: inline-block;

      }
      &__text-wrap {
        padding-left: 1.25rem;
        font-size: 1rem;
      }
      &__name {
        font-size: 1.5625rem;
        margin-bottom: 1.25rem;
      }
    }
    .interviewers-name {
      &__item {
        width: 8rem;
        height: 2.625rem;
        border-radius: 1.3125rem 1.3125rem 0 1.3125rem;
        font-size: 1rem;
        padding: 0.71875rem 1.625rem;
        &:nth-child(1) {
          left: -4.5rem;
          top: 6rem;
        }
        &:nth-child(2) {
          right: -1.5rem;
        }
        &:nth-child(3) {
          left: -1rem;
          bottom: 4rem;
        }
      }
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .landing-info {
      &__item {
        &.item-intro {
          &:after {
            top: 15rem;
            right: 0;
          }
          .landing-info__text-wrap {
            padding-top: 1.125rem;
          }
        }
        &.item-create {
          padding: 2rem 0;
          .landing-info__text-wrap {
            padding: 0;
          }
          .landing-info__image-wrap {
            padding: 0;
          }
          .landing-info__image {
            width: 32rem;
          }
        }
        &.item-test {
          padding-top: 2rem;
          &:after {
            content: none;
          }
          .landing-info__image-wrap {
            padding-left: 2.5rem;
          }
          .landing-info__text-wrap {
            padding-top: 2rem;
            padding-bottom: 3rem;
          }
        }
        &.item-conveniently {
          padding-bottom: 2rem;
          .landing-info__text-wrap {
            padding-top: 2rem;
          }
          .landing-info__image-wrap {
            padding: 2rem 2rem 0 0;
            &:after {
              width: 12rem;
              right: 0;
              bottom: 0;
            }
          }
        }
        &.item-aggregators {
          padding-bottom: 2rem;
          .landing-info__image-wrap {
            padding-top: 3.5rem;
            &:before {
              width: 10rem;
              top: 1.5rem;
              right: 2rem;
            }
          }
          .landing-info__text-wrap {
            padding-top: 1.5rem;
          }
        }
        &.item-office {
          padding: 2rem 0 2rem;
          .landing-info__image-wrap {
            padding: 0 0 1.5rem 2rem;
          }
        }
        &.item-integrate {
          .landing-info__image-wrap {
            padding-top: 2rem;
            padding-left: 4.5rem;
            &:after {
              width: 8.5rem;
              height: 7rem;
              left: 1.75rem;
              bottom: 2.5rem;
            }
          }
          .landing-info__text-wrap {
            padding-top: 1.5rem;
            padding-bottom: 2.5rem;
          }
        }
        &.item-qr {
          .landing-info__image-wrap {
            &:after {
              bottom: inherit;
              right: -30%;
              top: 1rem;
            }
          }
          .landing-info__text-wrap {
            &:before {
              top: inherit;
              left: -65%;
              bottom: -3rem;
            }
          }
        }
      }
      &__image {
        padding: 0;
        max-width: 80%;
      }
      &__text-wrap {
        padding: 0;
      }
    }
    .interviewers-name {
      &__item {
        &:nth-child(1) {
          left: -1rem;
          top: 6.5rem;
        }
        &:nth-child(2) {
          right: -1.5rem;
          top: 6.5rem;
        }
        &:nth-child(3) {
          left: 2.75rem;
          bottom: 4rem;
        }
      }
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .landing-info {
      &__item {
        &.item-intro {
          padding-bottom: 2rem;
          &:after {
            content: none;
          }
        }
        &.item-create {
          padding: 1.5rem 0 2rem;
          text-align: center;
          .landing-info__text-wrap {
            padding: 0;
          }
          .landing-info__image-wrap {
            padding: 0;
          }
          .landing-info__image {
            width: 19rem;
          }
        }
        &.item-test {
          .landing-info__image-wrap {
            padding: 0 1rem 0 2.5rem;
          }
          .landing-info__text-wrap {
            padding-top: 1.5rem;
            padding-bottom: 2rem;
          }
        }
        &.item-conveniently {
          padding-bottom: 2rem;
          .landing-info__text-wrap {
            padding-top: 1.5rem;
          }
          .landing-info__image-wrap {
            &:after {
              width: 35%;
              right: -1rem;
              bottom: -1.875rem;
            }
          }
        }
        &.item-aggregators {
          .landing-info__image-wrap {
            padding-top: 3rem;
            &:before {
              width: 35%;
              right: 0;
            }
          }
          .landing-info__text-wrap {
            padding-top: 1.5rem;
          }
        }
        &.item-office {
          .landing-info__image-wrap {
            padding: 0 0 1rem 1.5rem;
          }
        }
        &.item-integrate {
          .landing-info__image-wrap {
            padding-left: 20%;
            &:after {
              width: 29%;
              height: 7rem;
              left: 0;
              bottom: 0;
            }
          }
        }
        &.item-qr {
          .landing-info__text-wrap {
            padding-top: 1.5rem;
            padding-bottom: 1.5rem;
            &:before {
              content: none;
            }
          }
          .landing-info__image-wrap:after {
            content: none;
          }
          .landing-info__name {
            max-width: 17rem;
            margin-left: auto;
            margin-right: auto;
          }
        }
      }
      &__image {
        max-width: 100%;
      }
    }
    .interviewers-name {
      &__item {
        width: 5.875rem;
        height: 1.875rem;
        border-radius: 0.9375rem 0.9375rem 0 0.9375rem;
        font-size: 0.75rem;
        padding: 0.5rem 1.125rem;
        &:nth-child(1) {
          left: -1.5rem;
          top: 6rem;
          border-radius: 0.9375rem 0 0.9375rem 0.9375rem;
        }
        &:nth-child(2) {
          top: 7.5rem;
          border-radius: 0.9375rem 0.9375rem 0.9375rem 0;
        }
        &:nth-child(3) {
          left: 0.5rem;
          bottom: 3rem;
          border-radius: 0.9375rem 0.9375rem 0 0.9375rem;
        }
      }
    }
  }
  @media only screen and (max-width: 374px) {
    .landing-info {
      &__item {
        &.item-conveniently {
          .landing-info__image-wrap {
            padding-right: 1.5rem;
          }
        }
        &.item-qr .landing-info__name {
          max-width: 16rem;
        }
      }
      &__name {
        font-size: 1.4375rem;
        margin-bottom: 0.875rem;
      }
      &__text-wrap {
        font-size: 0.9375rem;
      }
    }
    .interviewers-name {
      &__item {
        &:nth-child(1) {
          left: 0;
        }
        &:nth-child(2) {
          right: -0.5rem;
        }
      }
    }
  }

</style>

<i18n locale="en" lang="yaml">
items:
  - title: Huntica will interview<br> your candidates for you
    text: "Tired of asking candidates the same questions, making appointments,
      adjusting to late arrivals? Our service was created to save you from
      the same old routine! Post a job, invite candidates, and let Huntica
      interview them for you. We will remind applicants about the interview,
      and our artificial intelligence will interview them without needing your participation.
      Find out how easy it is take a <a href='/en/demo'>test interview</a>"
    image: info1.png
    class: intro
  - title: Conveniently organize your workflow<br>with applicants
    text: "Change candidate statuses by dragging and dropping cards on the bulletin board.
      Filters, sorting, search - working with candidates has never been more convenient!"
    image: info4.svg
    class: conveniently
</i18n>

<i18n locale="ru" lang="yaml">
items:
  - title: Huntica проведет<br>собеседования за вас
    text: "Устали задавать кандидатам одни и те же вопросы, согласовывать встречи, подстраиваться под их опоздания? Наш сервис создан, чтобы снять с вас рутину! Разместите вакансию, пригласите кандидатов и позвольте Хантике провести собеседования за вас. Мы сами напомним соискателям про собеседование, а наш искусственный интеллект проведет его без вашего участия. Узнайте, как просто это работает –пройдите
      <a href='/ru/demo'>тестовое собеседование</a>!"
    image: info1.png
    class: intro
  - title: Работайте с соискателями удобно
    text: "Меняйте статусы кандидатов, перетягивая карточки на канбан-доске.
    Фильтры, сортировки, поиск – работа с кандидатами еще никогда не была такой удобной!"
    image: info4.svg
    class: conveniently
</i18n>
